import MyComponent from './component/MainComponent'
import styled from 'styled-components'
import DragAndDrop from './component/DragAndDrop';
import { useSpring, animated } from 'react-spring'
import { useDrag } from 'react-use-gesture'
import { useEffect, useState } from 'react'


const App = () => {
  
  const SCREEN_HEIGHT = window.innerHeight - 250;

  
  const handlePos = useSpring({y:0})
  
  const bHandlePos = useDrag((params) => {
    const y = params.xy[1]
    
    if (params.dragging) {
      if (y >= 0 && y <= SCREEN_HEIGHT) {
        handlePos.y.set(y);
      }
    } else {
      if (y > SCREEN_HEIGHT / 2) {
        handlePos.y.start(SCREEN_HEIGHT)
      } else {
        handlePos.y.start(0)
      }
    }
  })

  const mainSong = require('./music/smashmenutheme.mp3')

  const music = new Audio(mainSong)
  
  const [playMusic, setPlayMusic] = useState(false)

  const handleDrag = () => {
    setPlayMusic(!playMusic)
  }

  let play = () => {
      music.play();
  }

  let pause = () => {
    music.pause()
  }

  music.volume = 0.05


  

  return ( 
    <Container>
      <animated.div {...bHandlePos()} style={{
                y: handlePos.y,
            }}
      className="App-handle-container">
          <div onClick={play} className="App-handle"/>
      </animated.div>


      <animated.div
        style={{
          y: handlePos.y,
          opacity: handlePos.y.to([0, SCREEN_HEIGHT], [1, 1]),
      }}
      className="App-overlay">
        
        <h1 style={{
          margin: '0',
          textAlign : 'center',
          color: 'lightGray',
          fontSize: '24px',
          paddingTop: '40px'}}>Drag me Slowly!</h1>

          <h1 onClick={pause}
          className="stopbtn"
          >Stop Music</h1>

        </animated.div>
        



      <div className="App-bg">
        <h1>Let's Begin!</h1>
        <h1 className="fight-text">Fight!</h1>
        <div className="stage">
          <p>_________________</p>
          <h1>VS</h1>
          <p>_________________</p>
        </div>
        </div>
      <DragAndDrop/>
    </Container>
   );
}
 
export default App;

const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  height: 100%;
  width: 100%;

  .App-overlay {
        position: fixed;
        background-color: white;
        width: 100%;
        height: 100%;
        z-index: 1;
    }

  .App-bg {
      position: fixed;
      width: 100%;
      min-height: 70vh;
      height: auto;
      background-color: red;
      z-index: -2;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      
      align-items: center;
        h1 {
          color: white;
      }
      p {
        color: white;
      }
      .stage {
        display: flex;
        flex-direction: row;
        gap: 30px;
      }
    }

    .App-handle-container {
      width: 70px;
      height: 10px;
      top: 10px;
      position: fixed;
      z-index: 2;

      
      .App-handle {
        width: 70px;
        height: 10px;
        background-color: white;
        margin: 0 auto;
        border: 1px solid black;
        border-radius: 25px;
        opacity: 1;
        cursor: pointer;

        &:hover {
          background-color: black;
        }
      }
    }
    .stopbtn {
      cursor: pointer;
      margin: 0;
      text-align : center;
      color: lightGray;
      font-size: 24px;
      padding-top: 10px;
      &:hover {
        color: gray;
      }
    }
    .fight-text {
      animation: changing-color;
      animation-duration: 1s;
      color: white;
      animation-iteration-count: infinite;

      @keyframes changing-color {
        0% { color: white};
        100% { color: #810000}
      }
    }
`